import { MUITab } from "@abb/arcadia-ui-react"
import { useHashTab } from "../../../hooks/useHashTab"
import { Categories } from "./categories_tab/Categories"
import { Devices } from "./devices_tab/Devices"
import { Families } from "./families_tab/Families"

export function DevicesContainer() {
  const { activeTab, handleTabChange } = useHashTab("devices")

  return (
    <div>
      <MUITab
        tabItems={[
          { id: "devices", label: "Devices" },
          { id: "families", label: "Families" },
          { id: "categories", label: "Categories" },
        ]}
        value={activeTab}
        handleChange={handleTabChange}
      />

      {activeTab === "devices" && <Devices />}
      {activeTab === "families" && <Families />}
      {activeTab === "categories" && <Categories />}
    </div>
  )
}
